exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-container[data-v-32c57910]{background-color:#fff;max-width:1660px;margin:0 auto;margin-top:30px;padding:30px;border-radius:10px}.page-title[data-v-32c57910]{font-size:22px;font-weight:700;margin-bottom:25px}.upload-dropzone[data-v-32c57910]{width:440px;padding:40px;border-radius:20px!important;border:2px dashed #a8b0ff!important;background:#f7f8ff!important;-webkit-transition:.25s;transition:.25s;margin-bottom:30px}.upload-dropzone[data-v-32c57910]:hover{border-color:#6372ff!important;background:#eef0ff!important}.upload-dropzone i[data-v-32c57910]{font-size:48px;color:#6372ff;margin-bottom:10px}.upload-dropzone .el-upload__text strong[data-v-32c57910]{color:#4c5dff}.row-error[data-v-32c57910]{background:#fff1f0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32c57910","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SocarBulkAddOrder.vue
// module id = MDi1
// module chunks = 2